var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorBandaid = function SvgErrorBandaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 155
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EEF4",
    d: "m96 154.37-.195.12-.144-.33c-52.373-32.227-74.11-49.247-88.649-74.428-14.587-25.266-5.68-57.718 19.895-72.484C50.538-6.395 80.13-.165 96 20.791 111.87-.165 141.462-6.395 165.093 7.248c25.575 14.766 34.482 47.218 19.895 72.484-14.538 25.18-36.276 42.2-88.649 74.429l-.144.328-.195-.12z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1)rotate(-45 -26.146 227.773)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#005587",
    d: "M.5 23.023v114.35c0 12.439 10.085 22.523 22.526 22.523 12.443 0 22.526-10.083 22.526-22.524V23.023C45.552 10.584 35.467.5 23.026.5 10.584.5.5 10.583.5 23.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EEF4",
    stroke: "#005587",
    d: "M9.135 61.174v38.76a1.5 1.5 0 0 0 1.5 1.506h24.782a1.5 1.5 0 0 0 1.5-1.505V61.174a1.5 1.5 0 0 0-1.5-1.506H10.636c-.83 0-1.501.673-1.501 1.506z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 50.257,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 50.257,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 50.257,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 36,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 36,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 36,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.629,
    cy: 21.743,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.143,
    cy: 21.743,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 125.109,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 125.109,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 125.109,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 110.851,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 110.851,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 110.851,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.629,
    cy: 139.366,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.143,
    cy: 139.366,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 69.616 -3.416)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#005587",
    d: "M.5 23.023v114.35c0 12.439 10.085 22.523 22.526 22.523 12.443 0 22.526-10.083 22.526-22.524V23.023C45.552 10.584 35.467.5 23.026.5 10.584.5.5 10.583.5 23.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080C7",
    stroke: "#005587",
    d: "M9.135 61.174v38.76a1.5 1.5 0 0 0 1.5 1.506h24.782a1.5 1.5 0 0 0 1.5-1.505V61.174a1.5 1.5 0 0 0-1.5-1.506H10.636c-.83 0-1.501.673-1.501 1.506z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 50.257,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 50.257,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 50.257,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 36,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 36,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 36,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.629,
    cy: 21.743,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.143,
    cy: 21.743,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 125.109,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 125.109,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 125.109,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.873,
    cy: 110.851,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.386,
    cy: 110.851,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.899,
    cy: 110.851,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.629,
    cy: 139.366,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.143,
    cy: 139.366,
    fill: "#0080C7",
    rx: 1.799,
    ry: 1.782
  })))));
};
export default SvgErrorBandaid;